:host {
  display: block;
}

.bread-crumb-current {
  stroke: var(--clrs-color-bread-crumb-current);
  fill: var(--clrs-step-indicator-icon-valid);
}

.bread-crumb-current-outer {
  fill: var(--clrs-step-indicator-icon-valid);
}

.bread-crumb-completed {
  fill: var(--clrs-color-bread-crumb-completed);
}

.loader-icons-bar {
  stroke: var(--clrs-color-loader-icons-bar);
}
.loader-icons-bar-completed {
  fill: var(--clrs-color-loader-icons-bar-completed);
}
.loader-bar-icons__icon--default .loader-icons-bar-outer {
  fill: var(--clrs-icon-loader-bar-default);
}
.loader-bar-icons__icon--current .loader-icons-bar-outer {
  fill: var(--clrs-icon-loader-bar-current);
}
.loader-bar-icons__icon--complete .loader-icons-bar-completed-outer {
  fill: var(--clrs-icon-loader-bar-complete);
}